'use client'

import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ObjectSchema } from 'yup'

import useRequestState from 'shared/hooks/useRequestState'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'
import { newsletterSchema } from 'shared/utils/validators'

import { signUpToNewsletter } from '../api'
import { NewsletterFormType } from '../types'

export interface NewsletterSignupFormValues {
  email: string
  newsletterAgreement: boolean
}

interface UseNewsletterSignupFormOptions {
  formType?: NewsletterFormType
  onSignedUp?: (email: string) => void
}

export const useNewsletterSignupForm = ({
  formType = 'newsletter-agreement',
  onSignedUp
}: UseNewsletterSignupFormOptions = {}) => {
  const { setState, isLoading, isSuccess } = useRequestState()

  const methods = useForm<NewsletterSignupFormValues>({
    defaultValues: {
      email: '',
      newsletterAgreement: false
    },
    resolver: yupResolver(newsletterSchema as ObjectSchema<NewsletterSignupFormValues>)
  })

  const onSubmit = useCallback(async (data: NewsletterSignupFormValues) => {
    const emailLowerCase = data.email.toLowerCase()

    try {
      setState('loading')

      await signUpToNewsletter({
        email: emailLowerCase,
        formType
      })
      toast.success('Pomyślnie zapisano do newslettera')
      setState('success')


      onSignedUp?.(data.email)

      methods.reset()
      setState('idle')

    } catch (err) {
      toast.error(getApiErrors(err))
      setState('error')
      console.error(err)

    }
  }, [
    formType,
    methods,
    setState,
    onSignedUp,
  ])

  return {
    methods,
    onSubmit,
    isLoading,
    isSuccess
  }
}